<mat-radio-group
  [(ngModel)]="groupFilterKey">
  
<ul   class="action-btn-group">
    <li layout="column"> 
        <div class="header"><mat-radio-button value="entity">
            Entity
          </mat-radio-button>
        </div>
        <div class="content">Data will be selected based on entity and create multiple group of excution which can be shared between different respondents</div>
         
    </li>
    <li layout="column">
        <div class="header"> <mat-radio-button value="country">
            Country
          </mat-radio-button>
        </div>
        <div class="content">Data will be selected based on country and create multiple group of excution which can be shared between different respondents</div>
        
    </li>
    <li layout="column">
        <div class="header">
          <mat-radio-button value="region">
            Region
          </mat-radio-button>
        </div>
            <div class="content">Data will be selected based on region and create multiple group of excution which can be shared between different respondents</div>
  
    </li>
  </ul>
  
</mat-radio-group>

